import { ChatDto } from '@/lib/types';

// Sort by when the last message was sent, not `updated`: the backend bumps
// `updated` when a message is marked read, which would reorder chats on read.
export function compareChatsByLastMessage(a: ChatDto, b: ChatDto): number {
  return (
    new Date(b.lastMessage?.created ?? 0).getTime() -
    new Date(a.lastMessage?.created ?? 0).getTime()
  );
}
